<template>
  <div class="realize_wrap">
    <!-- 预约参观表单 -->
    <div class="appointment_wrap">
      <div class="appointment_form">
        <h2>预约参观</h2>
        <el-form :model="form" label-width="120px">
          <el-form-item label="姓名：">
            <el-input v-model="form.name" placeholder="填写您的称呼"></el-input>
          </el-form-item>
          
          <el-form-item label="电话：">
            <el-input v-model="form.phone" placeholder="填写您的电话"></el-input>
          </el-form-item>
          
          <el-form-item label="地区：">
            <el-input v-model="form.region" placeholder="填写您参观的地区"></el-input>
          </el-form-item>
          
          <el-form-item label="参观人数：">
            <el-input v-model="form.people" placeholder="填写您参观的人数"></el-input>
          </el-form-item>
          
          <el-form-item>
            <el-button type="primary" @click="submitForm">立即预约</el-button>
            <el-button type="info" @click="evaluateCost">费用评估</el-button>
          </el-form-item>
        </el-form>
      </div>
      
      <!-- 客服图片 -->
      <div class="customer_service">
        <img src="@/assets/customer_service.jpg" alt="客服人员" />
        <p style="position: absolute; top: 50%; left: 52%; font-size: 1rem; width: 30%;" >提交您的问题与需求，我们会尽快联系您或直接在线回复如果急需回复，请致电沟通。</p>
      </div>
    </div>

    <!-- 联系信息 -->
     <div class="location_box">
       <div class="contact_info_wrap">
         <div class="contact_item">
           <div class="icon"><i class="el-icon-location-outline"></i></div>
           <div class="title">地址</div>
           <div class="content">
             四川省成都市新都区蓉都大道南一段602号
           </div>
         </div>
         
         <div class="contact_item">
           <div class="icon"><i class="el-icon-phone"></i></div>
           <div class="title">电话</div>
           <div class="content">028-61621836</div>
         </div>
         
         <div class="contact_item">
           <div class="icon"><i class="el-icon-truck"></i></div>
           <div class="title">路线</div>
           <div class="content">
             成都市内可乘坐地铁三号线，从马超地铁C口出。
           </div>
         </div>
       </div>
     </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        name: '',
        phone: '',
        region: '',
        people: ''
      }
    }
  },
  methods: {
    submitForm() {
      // 提交预约表单
      console.log('提交预约:', this.form)
      // 这里可以添加实际的API调用
      this.$message.success('预约成功！我们将尽快与您联系。')
    },
    evaluateCost() {
      // 费用评估
      console.log('进行费用评估')
      // 这里可以添加实际的费用计算逻辑
      this.$message.info('费用评估功能正在开发中...')
    }
  }
}
</script>

<style lang="scss" scoped>
.realize_wrap {
  position: relative;
}

.appointment_wrap {
  width: 68vw;
  display: flex;
  justify-content: space-between;
  padding-top: 4rem;
  margin-bottom: 40px;
  margin: 0 auto;
  font-size: 1.5rem;
  position: relative;
  
  .appointment_form {
    width: 50%;
    height: 55vh;
    background: white;
    padding: 3rem;
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    position: absolute;
    bottom: 0;
    
    h2 {
      text-align: center;
      color: #FF8C00;
      margin-bottom: 1.4rem;
      font-size: 2rem;
    }
    
    .el-form-item {
      margin-bottom: 2.2rem;

      :deep(.el-form-item__label) {
        font-size: 1.2rem;
      }

      :deep(.el-input__inner) {
        height: 3rem;
        font-size: 1.3rem;
      }

      :deep(.el-button) {
        font-size: 1.2rem;
      }
    }
    
    .el-button {
      width: 120px;
      margin-right: 10px;
    }
    
    .el-button--primary {
      background-color: #FF8C00;
      border-color: #FF8C00;
      color: white;
    }
    
    .el-button--info {
      background-color: #409EFF;
      border-color: #409EFF;
      color: white;
    }
  }
  
  .customer_service {
    height: 33vh;
    width: 50%;
    background: white;
    border-radius: 8px;
    margin-left: auto;
    
    img {
      width: 100%;
      height: 100%;
    }
    
    p {
      color: #666;
      line-height: 1.5;
    }
  }
}

.location_box {
  width: 100vw;
  background-image: url('../../assets/location.png');
  position: relative;
  height: 20vh;
  margin: 20rem auto 0;
}

.contact_info_wrap {
  width: 68vw;
  display: flex;
  justify-content: space-between;
  padding: 1.4rem;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  position: absolute;
  bottom: 50%;
  left: 49.5%;
  transform: translateX(-50%);
  
  .contact_item {
    flex: 1;
    padding: 20px;
    text-align: center;
    
    .icon {
      font-size: 36px;
      color: #FF8C00;
      margin-bottom: 15px;
    }
    
    .title {
      font-size: 1.4rem;
      font-weight: bold;
      margin-bottom: 15px;
      color: #333;
    }
    
    .content {
      color: #666;
      line-height: 1.5;
      text-align: center;
      font-size: 1.2rem;
    }
  }
}
</style>